import { connect, ConnectedProps } from 'react-redux'
import { ButtonRed, ButtonSecondary } from '../../../../../../baseComponents/Button'
import { ModalMedium, ModalWithCloseButton } from '../../../../../../baseComponents/Modal'
import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps, ModalEditComponentPropsWithoutSubmit } from '../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import TwinForm from '../../../../../../forms/TwinForm'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads, appStore } from '../../../../../../utils/reducers'
import { PdfTemplatePayload } from '../../../../../../utils/reducers/company/pdfTemplates'
import { getActiveLangs, getCompany, getConfigParam, getUserPermissions } from '../../../../../../utils/reducers/getters'
import { getLang } from '../../../../../../utils/globals'
import { FormElement, FormRender } from '../../../../../../forms/FormRenderer/types'
import FormRenderer from '../../../../../../forms/FormRenderer'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import twinFetchPost, { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router'
import location from '../../../../../../utils/globals/locations'
import LoadingSpinner from '../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { OrderData } from '../../../OrderLayout/types'
import { Modify } from '@teinor/erp'
import locations from '../../../../../../utils/globals/locations'
import { CustomCustomerRenderWithLabel } from '../../../../../Customers/Subcomponents'
import { CustomRenderDisplayPriceWOParams } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { returnClassOfSpanTemplate } from '../../../../../../utils/globals/tailwind'
import { ModalCreateEditCustomerContactData, ShareQuoteCContactPersonSelectorParent } from './ShareQuoteCustomerContactPersonSelectors'
import SectionShareQuoteCEContactPerson from './ShareQuoteCustomerContactPersonSelectors/SectionShareQuoteCEContactPerson'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { ModalCreateEditStructureLayout } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import './modalShareQuote.sass'

type ModalShareBaseProps = Modify<ModalEditComponentProps, {
    allRowData: OrderData
}>
interface ModalShareAndUnshareQuoteProps extends ModalShareBaseProps {}

const ModalShareAndUnshareQuote: React.FC<ModalShareAndUnshareQuoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const employeeEmailParameter = useMemo(() => appStore.getState().user?.extraData.Employee?.EmployeeParameters?.emailManagerEmail, [])
    const publicToken = allRowData?.header?.publicToken

    if (!publicToken) {
        return employeeEmailParameter ? <ModalShareQuoteConnect {...{ setOpened, onSubmit, allRowData, publicToken }} /> : <ModalEmailNotConfigured setOpened={setOpened}/>
    } else {
        return <ModalSharedQuoteInformation {...{ setOpened, onSubmit, allRowData, publicToken }} />
    }
}

type ModalShareQuoteProps = ModalShareBaseProps & ReduxModalShareQuote & {}
const ModalShareQuote: React.FC<ModalShareQuoteProps> = ({ setOpened, allRowData, onSubmit, pdfTemplates }) => {
    const { t } = useTwinTranslation()
    const header = allRowData?.header
    const contactPersonPermission = getUserPermissions('customer.profile.contactPerson')
    const { setPdfTemplateId, loading, endLoading, PdfTemplateId, defaultShareMessage, setDefaultShareMessage, setType, type, returnModal, customerData, setCustomerData, customerContacts, getCustomerContactsData, handleBeforeSubmit } = useModalShareQuoteLogic({ setOpened, allRowData: header })
    const dictPdfQuoteOrderTemplates = dictionaryComplexFromJsonArr(pdfTemplates?.quoteOrder || {})
    const fields: FormRender<TwinDictionary> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'PdfTemplateId',
                    label: t('choosePdfTemplateToSend', 'Por favor, escoje qué plantilla de pdf quieres enviar'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictPdfQuoteOrderTemplates,
                    onChange: ((value) => setPdfTemplateId(value)),
                    required: true,
                },
                {
                    name: 'LangId',
                    label: t('lang', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: getLang()
                },
                {
                    name: 'CustomerContactPersonId',
                    component: 'Custom',
                    render: ({ extraProps }) => <ShareQuoteCContactPersonSelectorParent customerContacts={customerContacts} customerData={customerData} setCustomerData={setCustomerData} handleOpenModalBig={setType} extraProps={extraProps} />,
                    extraProps: {
                        CustomerContactPersonId: customerData?.CustomerContactPersonId,
                        customerContacts: customerContacts 
                    }
                },
                {
                    name: 'cc_emails',
                    label: t('AddCCEmailAddresses', 'Añadir destinatarios en copia'),
                    component: 'TextArea',
                    placeholder: t('Enter email addresses separated by commas','Escribe las direcciones de email separadas por coma'),
                },
                {
                    name: 'copyToRepresentative',
                    label: t('wantCopy', 'Quiero copia'),
                    component: 'CheckboxMargin',
                    defaultChecked: true
                },
                {
                    name: 'defaultShareMessage',
                    label: t('textShareQuote', 'Texto compartir Presupuesto'),
                    component: 'TextArea',
                    value: defaultShareMessage,
                    onChange: setDefaultShareMessage
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: header?.id,
                },
            ]
        }
    ]

    const gridCols = type ? 'grid-cols-5' : 'grid-cols-1'
    const secondDivClass = type ? ('border-l border-gray-DD pl-30 ' + returnClassOfSpanTemplate(2)) : ''
    
    return (
        <ModalWithCloseButton size={type ? 'modal_extrabig' : 'modal_little'} setOpenedReturn={returnModal} showCloseButton={type ? true : false} opened={true} setOpened={setOpened} className='text-gray-51 flex flex-col modal_share_quote' >
            <div className={'grid flex-auto ' + gridCols}>
                {type ?
                    <div className={'flex flex-col ' + returnClassOfSpanTemplate(3)}>
                        { <SectionShareQuoteCEContactPerson setCustomerData={setCustomerData} customerData={customerData} type={type || ''} setType={setType} userPermissions={contactPersonPermission || undefined} onSubmit={getCustomerContactsData} />
                        }
                    </div>
                    : null}
                <TwinForm action={'/api/app/order/quote/shareQuoteOrder'} onSubmit={(res, values) => {
                    onSubmit(res, values)
                    setOpened(null)
                }} className={'gap-y-10 flex flex-auto flex-col ' + secondDivClass} beforeSubmitHandler={handleBeforeSubmit} onError={() => endLoading()}>
                    <ModalCreateEditStructureLayout loading={loading} translations={{
                        title: t('sureShareQuote', '¿Seguro que quieres compartir este presupuesto?'),
                        button: t('accept', 'Aceptar')
                    }} haveButtonPermissions={true} className='modal_negative_margin flex-col' extraButtons={[<ButtonSecondary onClick={() => setOpened(null)}><TwinTrans transKey={'cancel'}>Cancelar</TwinTrans></ButtonSecondary>]}>
                        <div className='overflow-auto flex flex-auto flex-col gap-y-20'>
                            <span><TwinTrans transKey='customerWillReceiveALinkToCheckAndAcceptQuote'>El cliente recibirá un enlace para poder ver y aceptar tu presupuesto</TwinTrans></span>
                            {fields.length ?
                                <FormRenderer sections={fields} className='share_quote_form' />
                                : null}
                            <PaymentData allRowData={allRowData}/>
                            <DownloadPdfShareQuoteOrder Order={header} PdfTemplateId={PdfTemplateId || undefined} />
                        </div>
                    </ModalCreateEditStructureLayout>
                </TwinForm>
            </div>
        </ModalWithCloseButton>
    )
}

interface ModalShareQuoteLogicProps {
    setOpened: any
    allRowData: TwinDictionary
}

const useModalShareQuoteLogic = ({ setOpened, allRowData }: ModalShareQuoteLogicProps) => {
    const { t } = useTwinTranslation()
    const errorMessage = t('invalidCustomerContactEmail', 'El contacto del cliente no tiene un email válido')
    const errorFormatMessage = t('invalidEmailAddressesFromat', 'El formato de los destinatarios en copia es incorrecto')
    const { loading, startLoading, endLoading } = useIsLoading()
    const [type, setType] = useState<string | null>(null)
    const [customerContacts, setCustomerContacts] = useState<TwinDictionary[] | null>(null)
    const [customerData, setCustomerData] = useState<ModalCreateEditCustomerContactData>({
        CustomerId: allRowData?.CustomerId,
        CustomerContactPersonId: 0
    })
    const [PdfTemplateId, setPdfTemplateId] = useState<number | null>(null)
    const [defaultShareMessage, setDefaultShareMessage] = useState(t('yourNewQuoteOrderLink', 'Enlace para acceder a su nuevo presupuesto'))

    const getCustomerContactsData = useCallback(async () => {
        const myContactPersons = await twinFetchPostJSON('/api/app/customer/customerContactPerson/getAllCustomerContactPersons', { where: { CustomerId: allRowData?.CustomerId, '$or': { active: true } } })

        if (myContactPersons) {
            setCustomerContacts(myContactPersons || [])
        }
    }, [setCustomerContacts, allRowData])

    const returnModal = useCallback(() => {
        if (type) {
            setType(null)
        } else {
            setOpened(null)
            setCustomerData((old) => ({ ...old, CustomerContactPersonId: null }))
        }
    }, [type, setType, setOpened])

    const handleBeforeSubmit = useCallback((value: TwinDictionary) => {
        startLoading()
        if (!value?.shared_email) {
            changeErrorMessage(errorMessage)
            endLoading()
            return false
        }
        if (value?.cc_emails) {
            const emailAddresses = value?.cc_emails.split(',')
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            for (const email of emailAddresses) {
                if (!emailRegex.test(email.trim())) {
                    changeErrorMessage(errorFormatMessage)
                    endLoading()
                    return false;
                }
            }
        }
        return true
    }, [startLoading, errorMessage, endLoading, errorFormatMessage])

    useEffect(() => {
        getCustomerContactsData()
    }, [getCustomerContactsData])

    return { PdfTemplateId, setPdfTemplateId, loading, startLoading, endLoading, defaultShareMessage, setDefaultShareMessage, type, setType, customerData, setCustomerData, returnModal, customerContacts, getCustomerContactsData, handleBeforeSubmit }
}

interface DownloadPdfShareQuoteOrderProps extends DownloadPdfShareQuoteOrderLogicProps {}

const DownloadPdfShareQuoteOrder: React.FC<DownloadPdfShareQuoteOrderProps> = ({ PdfTemplateId, Order }) => {
    const {t} = useTwinTranslation()
    const { ref, downloadPdfWithTemplate, loading } = useDownloadPdfShareQuoteOrderLogic({Order, PdfTemplateId})
    if (!PdfTemplateId) {
        return null
    }
            
    return (
        <div ref={ref} >
            {!loading ? <div className='mt-15 mb-5 text-green-21 cursor-pointer' onClick={downloadPdfWithTemplate}>{t('quoteOrderPdfPreview', 'Vista previa del PDF del presupuesto')}</div> : <LoadingSpinner />}
            <a className='hidden downloadfile' download={true} href='/' target='_blank' onClick={(e) => e.stopPropagation()}>a</a>
        </div>   
    )
}

interface PaymentDataProps {
    allRowData: OrderData
}

const PaymentData: React.FC<PaymentDataProps> = ({allRowData}) => {
    const { paymentData, setPaymentData } = usePaymentDataLogic()
    const {tVars, t} = useTwinTranslation()
    const hasStripe = getConfigParam('stripeApi')
    const quoteMessage = tVars('quoteOrderPaymentMsg', 'Pago aceptación presupuesto {{full_assigned_number}}', { full_assigned_number: allRowData.header.full_assigned_number })
    if(!hasStripe){
        return null
    }
    const onOff = {
        'on': { name: t('on', 'Activado') },
        'off': { name: t('disabledS', 'Desactivado') },
    }
    let extraFields: FormElement<keyof TwinDictionary>[] = []
    const max = parseFloat(allRowData.header.total_total) - parseFloat(allRowData.header.total_payed || 0)
    if(paymentData === 'on'){
        extraFields = [
            {
                name: 'total_to_pay',
                label: t('totalToPay', 'Total a pagar'),
                component: 'InputPriceStateFull',
                CurrencyId: allRowData.header.CurrencyId,
                required: true,
                defaultValue: max,
                className: 'total_to_pay',
                maxValue: max
            },
            {
                name: 'pay_message',
                label: t('payDescription', 'Descripción de pago'),
                component: 'TextAreaStateFull',
                required: true,
                value: quoteMessage
            },
        ]
    }
    
    const fields: FormRender<TwinDictionary> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'requirePayment',
                    label: t('requirePaymentStripe', 'Requerir pago por stripe'),
                    component: 'CustomSelect',
                    items: onOff,
                    onChange: ((value) => setPaymentData(value)),
                    required: true,
                    value: paymentData
                },
                ...extraFields
            ]
        }
    ]
    return < FormRenderer sections={fields} className='share_quote_payment_data'/>
}


const usePaymentDataLogic = () => {
    const [paymentData, setPaymentData] = useState('off')
    return {paymentData, setPaymentData }
}


interface DownloadPdfShareQuoteOrderLogicProps {
    Order: TwinDictionary
    PdfTemplateId?: number
}

const useDownloadPdfShareQuoteOrderLogic = ({ Order, PdfTemplateId}: DownloadPdfShareQuoteOrderLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const ref = useRef<any>(null)
    const downloadPdfWithTemplate = useCallback(async () => {
        startLoading()
        const current = ref.current
        const result = await twinFetchPost('/api/app/order/quote/getQuoteOrderPdf', { id: Order.id, PdfTemplateId })
        if (result) {
            const pdf = await result.blob()
            const fileURL = URL.createObjectURL(pdf)
            const a = current.querySelector('a')
            const fileName = `${Order?.full_assigned_number}-${Order?.Customer?.fiscal_name || Order?.Customer?.name}`
            if (a) {
                a.href = fileURL
                a.download = fileName + '.pdf'
                a.click()
            }
            endLoading()
        }
    }, [Order, endLoading, startLoading, PdfTemplateId])

    return {ref, downloadPdfWithTemplate, loading}
}

interface ModalEmailNotConfiguredProps extends ModalEditComponentPropsWithoutSubmit {}

const ModalEmailNotConfigured: React.FC<ModalEmailNotConfiguredProps> = ({ setOpened }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => navigate(location.employeeParameters)} translations={{
            title: t('notPossibleShareQuote', 'No se puede compartir el presupuesto'),
            subtitle: t('NotEmailFoundedPleaseSetItInYourEmployeeEmailConfigPanel', 'Tu email no está definido. Por favor, configúralo en tu panel de parámetros del empleado.'),
            buttonAccept: t('goEmployeeParameters', 'Ir a parámetros'),
            buttonCancel: t('return', 'Volver')
        }} />
    )
}

type ModalSharedQuoteInformationProps = ModalShareQuoteInformationLogicProps & ModalShareBaseProps & {} 

const ModalSharedQuoteInformation: React.FC<ModalSharedQuoteInformationProps> = ({ setOpened, allRowData, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const header = allRowData?.header
    const { myContactPerson } = useModalShareQuoteInformationLogic({ ContactId: header?.CustomerContactPersonId })
    const extraElements: FormElement<keyof TwinDictionary>[]= []

    if (header?.cc_emails) {
        extraElements.push({
            name: 'cc_emails',
            component: 'TextField',
            label: t('CCEmailAddresses', 'Emails en copia'),
            value: header?.cc_emails.split(',').join(', ')
        })
    }
    if (header?.total_to_pay){
        extraElements.push({
            name: 'total_to_pay',
            component: 'Custom',
            render: () => <div className='flex flex-col'><span className='light12 text-gray-51 mb-4'>{t('pendingRequiredAmountToPay', 'Importe requerido pendiente de pagar')}</span><CustomRenderDisplayPriceWOParams value={allRowData.header.total_to_pay} CurrencyId={allRowData.header.CurrencyId} /></div>
        })
    }
    const fields: FormRender<TwinDictionary> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'CustomerName',
                    component: 'Custom',
                    render: () => <CustomCustomerRenderWithLabel label={t('customer', 'Cliente')} allRowData={{ Customer: header?.Customer }} />,
                },
                {
                    name: 'CustomerContactPersonName',
                    component: 'TextField',
                    value: myContactPerson?.name,
                    label: t('sendTo', 'Enviado a')
                },
                {
                    name: 'CustomerContactPersonEmail',
                    component: 'TextField',
                    value: myContactPerson?.email,
                    label: t('customerContactEmail', 'Email del contacto')
                },
                ...extraElements
            ]
        },
    ]

    const urlName = getCompany()?.urlName || ''
    return (
        <ModalMedium opened={true} setOpened={setOpened} onCancel={() => setOpened(null)}>
            <h2 className='mb-30'><TwinTrans transKey={'quoteSharedOrderInformation'}>Información sobre el presupuesto compartido</TwinTrans></h2>
            <FormRenderer sections={fields} className='grid_mincontent' />
            <Link className='cursor-pointer text-green-21' target='_blank' to={locations.sharedQuote + '/' + urlName + '/'+  header?.publicToken}><TwinTrans transKey={'seePublicQuoteOrderUrl'}>Ir al enlace público del presupuesto</TwinTrans></Link>
            <div className='w-full flex justify-end'>
                <ButtonRed className='mb-15 mt-30' onClick={() => setOpenModal({ allRowData: { ...allRowData }, type: 'edit' })}><TwinTrans transKey={'unshare'}>Descompartir</TwinTrans></ButtonRed>
            </div>
            {openModal?.type === 'edit' ? <ModalUnshareQuote setOpened={() => setOpened(null)} onSubmit={onSubmit} allRowData={{id: header.id}} /> : null}
        </ModalMedium>
    )
}

interface ModalShareQuoteInformationLogicProps {
    ContactId?: number
}

const useModalShareQuoteInformationLogic = ({ ContactId }: ModalShareQuoteInformationLogicProps) => {
    const [myContactPerson, setMyContactPerson] = useState<TwinDictionary | null>(null)

    const getData = useCallback(async () => {
        const myContactPersons = await twinFetchPostJSON('/api/app/customer/customerContactPerson/getCustomerContactPersonForDetail', { id: ContactId})
        setMyContactPerson(myContactPersons || {})
    }, [ContactId])

    useEffect(() => {
        getData()
    }, [getData])

    return { myContactPerson }
}

interface ModalUnshareQuoteProps extends ModalEditComponentProps {}

const ModalUnshareQuote: React.FC<ModalUnshareQuoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/quote/unshareQuoteOrder',
        data: allRowData || {}
    })

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnshareQuote', '¿Seguro que quieres dejar de compartir este presupuesto?'),
            subtitle: t('notPossibleForCustomerToSeeAndCheckQuoteAnymore', 'El cliente ya no podrá ver ni revisar el presupuesto'),
            buttonAccept: t('stopSharing', 'Descompartir'),
            buttonCancel: t('return', 'Volver')
        }} />
    )
}

const pdfTemplateDispatch = {
    setPdfTemplates: (payload: PdfTemplatePayload) => ({ type: 'CHANGE_PDFTEMPLATE', payload }),
}

export type ReduxModalShareQuote = ConnectedProps<typeof modalShareQuoteConnect>
const mapModalShareQuoteConnector = (state: AllReduxPayloads) => ({ pdfTemplates: state.pdfTemplates })
const modalShareQuoteConnect = connect(mapModalShareQuoteConnector, pdfTemplateDispatch)

const modalShareQuoteConnectLoading = withLoading(ModalShareQuote, [{ fetchUrl: '/api/app/config/pdfTemplate/getAllPdfTemplates', propName: 'pdfTemplates', setFunctionName: 'setPdfTemplates' }])

const ModalShareQuoteConnect = modalShareQuoteConnect(modalShareQuoteConnectLoading)

export default ModalShareAndUnshareQuote